import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { startLoading, endLoading } from '../../../actions/loadingActions';
import { updateNote } from '../../../actions/admin';
import {renderTextArea} from '../../forms/newcaso/Fields';
import {Button, ModalFooter} from "reactstrap";

class NoteEdit extends Component{
    constructor(props){
        super(props);
        this.state = {
        };
    }
    onSubmit(data){
        this.props.startLoading();
        this.props.updateNote({
            id: this.props.note.id,
            text: data[`note_${this.props.note.id}`]
        });
        this.props.cancel();
    }
    render(){
        const { handleSubmit } = this.props;
        return(
            <div className="alert alert-warning alert-dismissible fade show note" role="alert">
            <form ref="editNote" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <div className="row">
                    <Field
                        name={`note_${this.props.note.id}`}
                        type="text"
                        col="col-md-12"
                        rows="4"
                        placeholder="Escribe una nueva nota..."
                        component={renderTextArea}
                    />
                    <div className="col-md-12 text-right">
                        <Button color="link" onClick={this.props.cancel.bind(this)}>Cancelar</Button>{' '}
                        <Button color="warning" onClick={handleSubmit(this.onSubmit.bind(this))}><i className="fa fa-pencil-square-o" /> Guardar cambios</Button>
                    </div>
                </div>
            </form>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        caso_id: state.caso.id,
        initialValues: {
            [`note_${ownProps.note.id}`]: ownProps.note.text
        }
    };
};

NoteEdit = reduxForm({
    enableReinitialize: true,
    form: 'editNote',
})(NoteEdit);



export default NoteEdit = connect(mapStateToProps, {
    startLoading,
    endLoading,
    updateNote
})(NoteEdit);


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/notes/NoteEdit.jsx